import { App } from "../common/components"
import React from "react"
import ReactDOM from 'react-dom'

ReactDOM.render(
      <App />,
    document.getElementById('app')
)